/**
 * Desktop (lg+) styling for the snake info sections (Figma node 6672:168881).
 *
 * On phones each section is its own floating card; on desktop all sections are
 * **rows of one parent card** separated by hairlines. These classes flatten a
 * `CollapsibleSection`'s own Card chrome at lg+ so the parent card (rendered by
 * `SnakeMarketPage`) supplies the border/background instead.
 */

/** First row: no chrome and no divider. */
export const SNAKE_SECTION_ROW = 'lg:rounded-none lg:border-0 lg:bg-transparent';

/** Every row after the first: chrome stripped, hairline divider on top. */
export const SNAKE_SECTION_ROW_DIVIDED =
  'lg:rounded-none lg:border-x-0 lg:border-b-0 lg:border-stroke-soft lg:bg-transparent';

/** Header row height/padding at lg+ (64px rows per Figma). */
export const SNAKE_SECTION_HEADER = 'lg:min-h-[64px] lg:px-5';
